var _style, _rect, _g, _defs, _g2, _g3, _path, _path2, _g4, _polygon, _path3, _path4, _path5, _g5, _g6, _g7, _g8, _g9, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKalilinux(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:url(#SVGID_1_);stroke:#FFFFFF;stroke-width:0.7549;}\t.st1{fill:none;stroke:#9E9E9E;stroke-width:0.2602;}\t.st2{filter:url(#Adobe_OpacityMaskFilter);}\t.st3{opacity:0.75;mask:url(#SVGID_2_);}\t.st4{fill:none;stroke:#545454;stroke-width:0.2602;}\t.st5{fill:#2A4E69;}\t.st6{fill:#E8F0F5;}\t.st7{fill:#294F69;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.9732,
    y1: 59.8099,
    x2: 84.1644,
    y2: 59.8099,
    gradientTransform: "matrix(1 0 0 -1 0 100.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8F0F5"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 19.1,
    className: "st0",
    width: 67.2,
    height: 43.7
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 20.1,
    className: "st1",
    width: 65.6,
    height: 42.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 17.5,
    y: 19.9,
    width: 65.9,
    height: 42.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 17.5,
    y: 19.9,
    width: 65.9,
    height: 42.5,
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 487,
    height: 316,
    transform: "matrix(-0.1369 0 0 0.1369 83.7874 19.5214)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 20.1,
    className: "st4",
    width: 65.6,
    height: 42.3
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.2,18.5l0.1,44.8l5.6,0.1l0.1,2h27.8l-0.1-2l16.8-0.1v2.1h12.3l-0.1-2h6.1V18.5H16.2z M17.5,20.1h65.8       v42.2H17.5V20.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M98.3,80c0,0-0.3,0.9-1.2,1.5H2.9c0,0-1.2-0.5-1.2-1.3c0-0.9,2.5-1.1,2.5-1.1h93.3      C97.5,79.1,98.3,79.3,98.3,80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M84.4,66l13,11.3c0,0,0.9,0.8,0.9,2.7L1.7,80.2c0,0,0.3-2.4,1.3-3.1c1.1-0.7,12.7-11,12.7-11L84.4,66z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "13.3,71.8 17.8,67.4 82.5,67.3 86.8,71.8      "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M82.4,67.5l4,4.2H13.7l4.1-4.1L82.4,67.5 M82.6,67.2l-64.8,0.1L12.9,72h74.3L82.6,67.2L82.6,67.2z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "60.9,73 62.1,75.3 42.7,75.3 43.4,73     "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49.7,65.6c0,0.6-0.3,1,0.7,1h15.1c1,0,0.9-0.5,0.9-1.2l0,0c0-0.6,0.1-1.2-0.9-1.2H50.4      C49.4,64.3,49.7,65,49.7,65.6L49.7,65.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M15.7,65.6c0,0.6-0.1,1,0.3,1h5.6c0.4,0,0.4-0.5,0.4-1.2l0,0c0-0.6,0-1.2-0.4-1.2H16      C15.6,64.3,15.7,65,15.7,65.6L15.7,65.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M78.8,65.6c0,0.6-0.1,1,0.3,1h5.2c0.3,0,0.3-0.5,0.3-1.2l0,0c0-0.6,0-1.2-0.3-1.2H79      C78.7,64.3,78.8,65,78.8,65.6L78.8,65.6z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "17.1,67.9 17.1,67.9 83.1,67.9 83.1,67.9 83.1,67.9 83.1,67.9 17.1,67.9      "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M17.2,68h65.9l0.1-0.2H17.1L17.2,68z M17.2,68h65.9l0-0.2h-66L17.2,68z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "16.3,68.9 16.3,68.9 84.1,68.9 84.1,68.9 84.1,68.9 84.1,68.9 16.3,68.9      "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M16.3,68.9H84l0.1-0.2H16.3L16.3,68.9z M16.3,68.9H84l0.1-0.2H16.2L16.3,68.9z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "15.2,69.9 15.2,69.9 85.1,69.9 85.1,69.9 85.1,69.9 85.1,69.9 15.2,69.9      "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M15.3,70H85l0.1-0.2H15.2L15.3,70z M15.3,70H85l0.1-0.2h-70L15.3,70z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "14.1,70.9 14.1,70.9 86,70.9 86,70.9 86,70.9 86,70.9 14.1,70.9      "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M14.3,71h71.7l0.1-0.2H14.1L14.3,71z M14.3,71h71.7l0.1-0.2H14.1L14.3,71z"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.2,55) scale(0.0025,-0.0025) ",
    fill: "#2A4E69",
    stroke: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(27,22) scale(1.75)",
    d: "M12.778 5.943s-1.97-.13-5.327.92c-3.42 1.07-5.36 2.587-5.36 2.587s5.098-2.847 10.852-3.008zm7.351 3.095.257-.017s-1.468-1.78-4.278-2.648c1.58.642 2.954 1.493 4.021 2.665zm.42.74c.039-.068.166.217.263.337.004.024.01.039-.045.027-.005-.025-.013-.032-.013-.032s-.135-.08-.177-.137c-.041-.057-.049-.157-.028-.195zm3.448 8.479s.312-3.578-5.31-4.403a18.277 18.277 0 0 0-2.524-.187c-4.506.06-4.67-5.197-1.275-5.462 1.407-.116 3.087.643 4.73 1.408-.007.204.002.385.136.552.134.168.648.35.813.445.164.094.691.43 1.014.85.07-.131.654-.512.654-.512s-.14.003-.465-.119c-.326-.122-.713-.49-.722-.511-.01-.022-.015-.055.06-.07.059-.049-.072-.207-.13-.265-.058-.058-.445-.716-.454-.73-.009-.016-.012-.031-.04-.05-.085-.027-.46.04-.46.04s-.575-.283-.774-.893c.003.107-.099.224 0 .469-.3-.127-.558-.344-.762-.88-.12.305 0 .499 0 .499s-.707-.198-.82-.85c-.124.293 0 .469 0 .469s-1.153-.602-3.069-.61c-1.283-.118-1.55-2.374-1.43-2.754 0 0-1.85-.975-5.493-1.406-3.642-.43-6.628-.065-6.628-.065s6.45-.31 11.617 1.783c.176.785.704 2.094.989 2.723-.815.563-1.733 1.092-1.876 2.97-.143 1.878 1.472 3.53 3.474 3.58 1.9.102 3.214.116 4.806.942 1.52.84 2.766 3.4 2.89 5.703.132-1.709-.509-5.383-3.5-6.498 4.181.732 4.549 3.832 4.549 3.832zM12.68 5.663l-.15-.485s-2.484-.441-5.822-.204C3.37 5.211 0 6.38 0 6.38s6.896-1.735 12.68-.717z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKalilinux);
export default __webpack_public_path__ + "static/media/kalilinux.c86f9a1dab1d1c505eee4145ab2b3c51.svg";
export { ForwardRef as ReactComponent };